import React from 'react';
import { useEffect, useState } from "react";
import "../../../assets/css/master.css"
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../commonClass/Session';
import { generatePDF } from '../../commonClass/CommonValidation';
import { ExportExcel } from '../../commonClass/ExportExcel';
import CommonFilter from '../../../customControl/CommonFilter';
import CustomTable from '../../../customControl/CustomTable';
import { encrypt } from '../../commonClass/enc_dec/enc_dec';


const ManageActivityList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [manageActivityList, setManageActivityList] = useState([]);
    const [filterList, setFilterList] = useState([]);

    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSearchDisabled] = useState(false);

    //#region handle rights
    useEffect(() => {
        if (user?.length > 0) {
            const pathName = window?.location?.pathname?.toLowerCase();
            const hasRights = user?.find(x => x?.PageLink?.toLowerCase() === pathName)
            if (!hasRights?.URightView) {
                navigate("/dashboard");
                return;
            }
            setUserAdd(hasRights?.URightAdd);
            setUserEdit(hasRights?.URightEdit);
            setUserExport(hasRights?.URightExport);
        }
    }, [user])
    //#endregion

    //#region API calling functions
    const getactivitymanagelist = async () => {
        const activitymanagelist = await getAllData("/master/v1/getactivitymanagelist");
        if (activitymanagelist?.status) {
            activitymanagelist?.data?.map((obj, index) => {
                obj.SrNo = index + 1;
                return obj;
            })
            setManageActivityList(activitymanagelist?.data ? activitymanagelist?.data : []);
            setFilterList(activitymanagelist?.data ? activitymanagelist?.data : []);
        }
        else {
            setManageActivityList([]);
            setFilterList([]);
        }
    }


    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.allSettled([
                    getactivitymanagelist()
                ])
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" })
            }
        }
        fetchData();
    }, [])
    //#endregion


    const columns = [
        {
            name: 'Activity Name',
            key: 'ActivityName',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.ActivityName
        },
        {
            name: 'Activity Id',
            key: 'ActivityCode',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.ActivityCode
        },
        {
            name: 'Category',
            key: 'CategoryName',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.CategoryName
        },
        {
            name: 'City',
            key: 'City',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (el) => el?.City
        },
        {
            name: 'Status',
            key: 'Status',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: false,
            isExport: true,
            selector: (el) => el?.Status
        },
        {
            name: 'Edit',
            isSearch: false,
            isExport: false,
            selector: (el) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditManageActivity(el?.ActivityBasicInfoId)}></i></button>
        },
        {
            name: 'View',
            isSearch: false,
            isExport: false,
            selector: (el) => <button type='button' className='border-0 p-0 bg-body set_disableclr'><i className="fa fa-eye" onClick={() => handleViewManageActivity(el?.ActivityBasicInfoId)}></i></button>
        }
    ];

    const handleOpenManageActivity = () => {
        localStorage.setItem("ami", encrypt(0));
        navigate('/Manageactivitymaster', { state: { disabled: false, editdisabled: false, mode: 'Add', id: 0 } });
    }

    const handleEditManageActivity = (id) => {
        localStorage.setItem("ami", encrypt(id));
        navigate('/Manageactivitymaster', { state: { disabled: false, editdisabled: true, mode: 'Update', id: id } });
    }

    const handleViewManageActivity = (id) => {
        localStorage.setItem("ami", encrypt(id));
        navigate('/Manageactivitymaster', { state: { disabled: true, editdisabled: true, mode: 'View', id: id } });
    }


    //#region pdf export function
    const PDFExport = () => {
        const pdfColumns = columns?.flatMap((prev) => prev?.isExport ? [prev?.name] : []);
        const keys = columns?.flatMap((prev) => prev?.isExport ? [prev?.key] : []);
        const rows = manageActivityList?.map((obj) => keys?.map((key) => obj?.[key]))
        generatePDF(pdfColumns, rows, "Activity Information", "Activity Information")
    }
    //#endregion

    //#region excel export function
    const ExcelExport = () => {
        const dispalyname = columns?.flatMap((prev) => prev?.isExport ? [prev?.name] : []);
        const fields = columns?.flatMap((prev) => prev?.isExport ? [prev?.key] : []);
        ExportExcel(dispalyname, fields, manageActivityList, "Activity Information", "Activity Information.xls");
    }
    //#endregion

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Activity Information</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="d-flex justify-content-start ms-lg-3">
                        <button type="button" disabled={!useradd} className="btn btn-primary mx-1" id="btnAdd" onClick={handleOpenManageActivity} >Create New Activity</button>
                    </div>

                    <CommonFilter
                        columns={[
                            ...columns?.filter((prev) => prev.isSearch),
                            { name: "Active", key: "Active" },
                            { name: "Accuracy approved", key: "Accuracy approved" },
                            { name: "Contant Approved.", key: "Contant Approved." },
                            { name: "Draft", key: "Draft" },
                            { name: "Rejects", key: "Rejects" },
                        ]}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getactivitymanagelist}
                        setlistdata={setManageActivityList}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={manageActivityList}
                        PdfExport={PDFExport}
                        ExportToExcel={ExcelExport}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default ManageActivityList